import { NgModule } from '@angular/core';
import { MsEmptyComponent } from './ms-empty.component';
import { SharedLibsModule } from 'app/shared/shared-libs.module';

@NgModule({
	declarations: [MsEmptyComponent],
	imports: [SharedLibsModule],
	exports: [MsEmptyComponent],
	providers: [],
})
export class MsEmptyModule {}
